// src/pages/ForgotPassword.js
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const FEATURES = [
  'Communication & Collaboration',
  'Leadership Effectiveness',
  'Psychological Safety',
  'Goals & Role Clarity',
  'Morale & Wellbeing',
];

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await resetPassword(email);
      setSent(true);
    } catch (err) {
      // Don't reveal whether the email is registered — avoids leaking account existence.
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout">
      {/* Left hero panel */}
      <div className="auth-hero">
        <img src="/logo-white.png" alt="Meeting.Training" className="auth-hero-logo" />

        <h1>
          Understand<br />
          your team's<br />
          <em>heartbeat.</em>
        </h1>
        <p>
          Evidence-based assessments that reveal how your team truly works — and how to make it better.
        </p>

        <div className="auth-hero-features">
          {FEATURES.map((f) => (
            <div key={f} className="auth-hero-feature">
              <div className="auth-hero-feature-dot" />
              <span>{f}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Right form panel */}
      <div className="auth-form-panel">
        <div className="auth-form-box fade-up">
          {sent ? (
            <>
              <h2>Check your email</h2>
              <p className="subtitle">
                If an account exists for <strong>{email}</strong>, we've sent a link to reset your password.
              </p>
              <p style={{ textAlign: 'center', fontSize: '0.85rem', color: 'var(--ink-muted)', marginTop: 18 }}>
                <Link to="/login" className="link">Back to sign in</Link>
              </p>
            </>
          ) : (
            <>
              <h2>Reset your password</h2>
              <p className="subtitle">Enter your email and we'll send you a reset link</p>

              {error && <div className="alert alert-error">{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Email address</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@company.com"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-full" disabled={loading} style={{ marginTop: 4 }}>
                  {loading ? <><span className="spinner" /> Sending...</> : 'Send reset link →'}
                </button>
              </form>

              <hr className="divider" />

              <p style={{ textAlign: 'center', fontSize: '0.85rem', color: 'var(--ink-muted)' }}>
                <Link to="/login" className="link">Back to sign in</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
